import { Link } from "../../../../node_modules/react-router-dom/dist/index";
import { useForm } from "react-hook-form";
import { SUBSCRIBE_US, fetchData } from "../../Service";
import { toast } from "react-toastify";
import { NavLink } from "react-router-dom";

const Footer = () => {
	const {
		register,
		handleSubmit,
		formState: { errors },
		reset,
	} = useForm({ mode: "onChange" });

	const onSubmit = (data) => {
		let payload = {
			email_id: data?.email,
		};

		fetchData(SUBSCRIBE_US, "POST", payload, true, false, (res) => {
			if (res.status) {
				toast.success("You have successfully subscribed.");
				reset();
			} else {
				toast.error("Unable to subscribe.");
			}
		});
	};

	return (
		<footer className="pb-2 mt-1" id="contactus">
			<div className="container-lg pt-3">
				<div className="row">
					<div className="col-lg-4 col-sm-6 mb-3">
						<h4 className="mb-3">Quick Links</h4>
						<div className="row">
							<div className="col-6">
								<ul>
									<li>
										<Link to="/about-us">About Us</Link>
									</li>
									<li>
										<Link to="/privacy">Privacy</Link>
									</li>
									<li>
										<Link to="/disclaimer">Disclaimer</Link>
									</li>
								</ul>
							</div>
							<div className="col-6">
								<ul>
									<li>
										<Link to="/advertise-with-us">Advertise</Link>
									</li>
									<li>
										<Link to="/terms-and-conditions">Terms & Conditions</Link>
									</li>
									<li>
										<Link to="/contact-us">Contact Us</Link>
									</li>
								</ul>
							</div>
						</div>
					</div>
					<div className="col-lg-4 col-sm-6 mb-3">
						<h4 className="mb-3"> Contact Information</h4>
						<ul>
							<li>
								<div className="address">
									{" "}
									<i className="icon">
										<img src="/assets/images/icons/map.svg" alt="..." />
									</i>
									<p>
										<span className="fw-bold">Address:</span> Shibis, KM0 Mogadishu USA
									</p>
								</div>
							</li>
							<li>
								<div className="address">
									{" "}
									<i className="icon">
										<img src="/assets/images/icons/phone.svg" alt="..." />
									</i>
									<p>
										<span className="fw-bold">Phone:</span> 844-435-7674
									</p>
								</div>
							</li>
							<li>
								<div className="address">
									{" "}
									<i className="icon">
										<img src="/assets/images/icons/email.svg" alt="..." />
									</i>
									<p>
										<span className="fw-bold">Email:</span> <a href="mailto:info@nris.com">info@nris.com</a>
									</p>
								</div>
							</li>
						</ul>
					</div>
					<div className="col-lg-4 col-md-12 mb-3">
						<h4 className="mb-3 mb-md-4">Stay updated on our mission - Subscribe for updates</h4>
						<form onSubmit={handleSubmit(onSubmit)}>
							<div className="input-group subscribe">
								<input
									type="text"
									className="form-control border-end-0"
									placeholder="Email"
									aria-label="Email"
									aria-describedby="basic-addon1"
									maxLength={120}
									{...register("email", {
										required: { value: true, message: "Email is required." },
										pattern: { value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/, message: "Email is invalid." },
									})}
								/>
								<span className="input-group-text p-0 bg-white" id="basic-addon1">
									<button type="submit" className="btn">
										Subscribe
									</button>
								</span>
							</div>
							{errors.email && <div className="invalid-feedback d-block m-0">{errors.email.message}</div>}
						</form>
						<div className="mt-3 d-block d-sm-flex justify-content-center justify-content-sm-end align-items-center gap-3">
							<div className="d-block d-sm-flex justify-content-center justify-content-sm-end text-center text-sm-start ">
								<NavLink to='https://srmtechsol0-my.sharepoint.com/:u:/g/personal/ankit_agrahari_srmtechsol_com/EQV7xDwSpWJLkHZeqQQSLHQBwF9jRmgR_DhxzvWfWn9aEA?e=nRDxfn' target="_blank">

								<img src="https://charity.africa/images/google.svg" className="me-2" alt="Google Play Store" style={{ height: '40px', width: 'auto' }} />
								</NavLink>
								<img src="https://charity.africa/images/apple.svg" alt="Apple App Store" style={{ height: '40px', width: 'auto' }} />
							</div>
							
							<div className="ms-auto mt-autov text-center text-sm-end mt-3 mt-sm-0">
								<ul className="social d-flex justify-content-center justify-content-sm-end list-unstyled mb-0 gap-3 mt-1">
									<li>
										<a href="https://www.facebook.com/welovenris" title="Facebook" target="_blank">
											<img src="/assets/images/icons/fb.svg" alt="Facebook" />
										</a>
									</li>
									<li>
										<a href="https://www.twitter.com" title="Twitter" target="_blank">
											<img src="/assets/images/icons/tw.svg" alt="Twitter" />
										</a>
									</li>
									<li>
										<a href="https://www.linkedin.com" title="Linkedin " target="_blank">
											<img src="/assets/images/icons/li.svg" alt="Linkedin" />
										</a>
									</li>
									<li>
										<a href="https://www.instagram.com" title="Instagram" target="_blank">
											<img src="/assets/images/icons/in.svg" alt="Instagram" />
										</a>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-12 text-center copyright">
						{" "}
						Copyright © {new Date().getFullYear()} <span className="fw-bold bacecolor">nris.com</span>
					</div>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
